<template>
  <div  class="msg_box">
	  <div class="magtop60">
	  <iframe src="https://dojindo.cn/calc/index2.html" width="1200px" frameBorder=0 height="2000px" scrolling="auto" marginWidth=0 marginHeight=0 ></iframe>
			<!-- <moer></moer> -->
	  </div>
  </div>
</template>

<script>
export default {
}
</script>

<style lang="scss" scoped>
	
</style>